import { createSlice } from '@reduxjs/toolkit';

const StationSlice = createSlice({
  name: 'StationSlice',
  initialState: {
    isLoading: false,
    isViewLoading: false,
    stationListData: [],
    isError: null,
    viewStationDetails: null,
    powerBankOnlineOfflineList: [],
    stationAttentionData: [],
    isAttentionLoading: false,
    isEjectLoading: false,
    ejectData: [],
    stationSummaryData: null,
    isSummaryLoading: false,
  },
  reducers: {
    /////// Station list start //////

    requestStationList: (state) => {
      return { ...state, isLoading: true };
    },
    responseStationList: (state, action) => {
      return {
        ...state,
        isLoading: false,
        stationListData: action?.payload?.data,
      };
    },
    failureStationList: (state, action) => {
      return {
        ...state,
        isLoading: false,
        isError: action?.payload,
      };
    },

    /////// Station Add-Edit //////
    requestStationAdd: (state) => {
      return { ...state, isLoading: true };
    },
    responseStationAdd: (state) => {
      return { ...state, isLoading: false };
    },
    failureStationAdd: (state, action) => {
      return { ...state, isLoading: false, isError: action?.payload };
    },

    ////////// Station View /////////
    requestStationView: (state) => {
      return { ...state, isViewLoading: true };
    },
    responseStationView: (state, action) => {
      return {
        ...state,
        isViewLoading: false,
        viewStationDetails: action.payload,
      };
    },
    failureStationView: (state, action) => {
      return { ...state, isViewLoading: false, isError: action?.payload };
    },

    ///// Eject powerbank ////
    requestEjectPowerbank: (state) => {
      return { ...state, isEjectLoading: true };
    },
    responseEjectPowerbank: (state, action) => {
      return { ...state, isEjectLoading: false, ejectData: action?.payload };
    },
    failureEjectPowerbank: (state, action) => {
      return { ...state, isEjectLoading: false, isError: action?.payload };
    },
    removeEjectedPowerbankFromStation: (state, action) => {
      return {
        ...state,
        viewStationDetails: {
          ...state.viewStationDetails,
          powerbank: action.payload,
        },
      };
    },

    ////// Station Delete ////
    requestStationDelete: (state) => {
      return { ...state, isLoading: true };
    },
    responseStationDelete: (state) => {
      return { ...state, isLoading: false };
    },
    failureStationDelete: (state, action) => {
      return { ...state, isLoading: false, isError: action?.payload };
    },

    ///////// powerbank is online offline /////
    requestPowerBnakIsOnlineOffline: (state) => {
      return { ...state, isLoading: true };
    },
    responsePowerBnakIsOnlineOffline: (state, action) => {
      return {
        ...state,
        isLoading: false,
        powerBankOnlineOfflineList: action?.payload,
      };
    },
    failurePowerBnakIsOnlineOffline: (state, action) => {
      return { ...state, isLoading: false, isError: action?.payload };
    },

    ////////// Station attentions /////////
    requestStationAttentionsList: (state) => {
      return { ...state, isAttentionLoading: true };
    },
    responseStationAttentionsList: (state, action) => {
      return {
        ...state,
        isAttentionLoading: false,
        stationAttentionData: action?.payload?.data,
      };
    },
    failureStationAttentionsList: (state, action) => {
      return {
        ...state,
        isAttentionLoading: false,
        isError: action?.payload,
      };
    },

    ////////// Station Summary /////////
    requestStationSummary: (state) => {
      return { ...state, isSummaryLoading: true };
    },
    responseStationSummary: (state, action) => {
      return {
        ...state,
        isSummaryLoading: false,
        stationSummaryData: action?.payload?.data,
      };
    },
    failureStationSummary: (state, action) => {
      return {
        ...state,
        isSummaryLoading: false,
        isError: action?.payload,
      };
    },

    ////// Sync Station Sheet ////
    requestSyncStationSheet: (state) => {
      return { ...state, isStationSheetLoading: true };
    },
    responseSyncStationSheet: (state) => {
      return { ...state, isStationSheetLoading: false };
    },
    failureSyncStationSheet: (state, action) => {
      return {
        ...state,
        isStationSheetLoading: false,
        isError: action?.payload,
      };
    },
  },
});

export const {
  failureStationList,
  responseStationList,
  requestStationList,
  failureStationAdd,
  requestStationAdd,
  responseStationAdd,
  failureStationView,
  requestStationView,
  responseStationView,
  failureStationDelete,
  requestStationDelete,
  responseStationDelete,
  failurePowerBnakIsOnlineOffline,
  requestPowerBnakIsOnlineOffline,
  responsePowerBnakIsOnlineOffline,
  failureStationAttentionsList,
  requestStationAttentionsList,
  responseStationAttentionsList,
  failureEjectPowerbank,
  requestEjectPowerbank,
  responseEjectPowerbank,
  removeEjectedPowerbankFromStation,
  requestStationSummary,
  responseStationSummary,
  failureStationSummary,
  requestSyncStationSheet,
  responseSyncStationSheet,
  failureSyncStationSheet,
} = StationSlice.actions;
export default StationSlice.reducer;
